{
    "MakeCallTitle": "Make Call",
    "MakeCallTooltip": "Make a call to the corresponding device.",
    "IttTitle": "Inquiry Transfer",
    "IttTooltip": "Make an inquiry consultation call to the corresponding device in order to begin a call transfer operation.",
    "CallDetailsTitle": "Call Details...",
    "CallDetailsTooltip": "Display detailed call information in a new window.",
    "CompleteTransferTitle": "Complete Transfer",
    "CompleteTransferTooltip": "Complete the previously started inquiry call transfer operation by moving the call on hold to the previously called target destination.",
    "PickupThisCallTitle": "Pickup This Call",
    "PickupThisCallTooltip": "Answered this alerting call immediately at your own extension.",
    "StealThisCallTitle": "Steal This Call",
    "StealThisCallTooltip": "Move the currently answered or alerting call to your extension where it will subsequently ring.",
    "SendToCallTitle": "Send Call To...",
    "SendToCallTooltip": "Move the currently answered or alerting call to a specific new destination where it will subsequently ring.",
    "MonitorTitle": "Monitor",
    "MonitorTooltip": "Device and call monitor options.",
    "SilentMonitorTitle": "Silent Monitor",
    "SilentMonitorTooltip": "Start a silent monitor session with the currently answered call at the device.",
    "ForcedIntrudeTitle": "Forced Intrude",
    "ForcedIntrudeTooltip": "Intrude (barge) into the currently answered call at the corresponding device, so that you can actively participate within that call.",
    "RecordCallTitle": "Record Call",
    "RecordCallTooltip": "Perform a live call recording operation on the currently answered call at the device.",
    "RegisterCallbackTitle": "Register Callback",
    "RegisterCallbackTooltip": "Display a message at the corresponding device, reminding them to call your particular extension back.",
    "AgentSignInOutTitle": "Agent Sign-In/Out",
    "AgentSignInOutTooltip": "Sign In/Out of extension.",
    "SignInTitle": "Sign In...",
    "SignInTitleAllGroups": "Sign In (All Groups)",
    "SignInTooltip": "Sign the corresponding device or agent in, making them 'on-duty'and potentially available to answer ACD calls.",
    "SignOutTitle": "Sign Out",
    "SignOutTitleAllGroups": "Sign Out (All Groups)",
    "SignOutTooltip": "Sign the corresponding device or agent out, making them 'off-duty' and unavailable to answer ACD calls.",
    "GroupsTitle": "Groups",
    "GroupsTooltip": "Choose which ACD groups this agent is signed into.",
    "NoGroupsTooltip": "No ACD Groups were found for this Agent.",
    "GroupsAllTitle": "[All]",
    "SetDndOnTitle": "Set DND On",
    "SetDndOnTooltip": "Turn on do-not-disturb at the device, which will make it unavailable to receive calls.",
    "SetDndOffTitle": "Set DND Off",
    "SetDndOffTooltip": "Turn off do-not-disturb at the device, which will make it available to receive inbound calls.",
    "SetStatusTitle": "Set Status",
    "SetStatusTooltip": "Set ACD status for this agent.",
    "SetAccountCodeMenuOptionTitle": "Set Account Code",
    "SetAccountCodeMenuOptionTooltip": "Set account code for this call.",
    "NoAccountCodeMenuOptionTitle": "[No account code]",
    "NoAccountCodeMenuOptionTooltip": "Unset the account code",
    "AccountCodeMenuOptionTooltip": "Set account code '{}' for the call.",
    "AvailableTitle": "Available",
    "AvailableTooltip": "Set the agent to the Available state, which will make them available to answer ACD calls.",
    "DndTitle": "DND",
    "DndTooltip": "Set the agent to the DND state, which will make them unavailable to answer ACD calls.",
    "WrapUpTitle": "Wrap-up",
    "WrapUpTooltip": "Set the agent into Wrap-Up state, which will make them unavailable to answer ACD calls.",
    "NotAvailableTitle": "Not-Available",
    "NotAvailableTooltip": "Set the agent into Not-Available ACD state and additionally specify a reason code, which can be used to identify why the corresponding agent is specifically unavailable to answer ACD calls.",
    "NoReasonTitle": "[No Reason]",
    "NoReasonTooltip": "Set the agent into Not Available ACD state providing no reason.",
    "AdvancedTooltip": "Advanced call control actions.",
    "AnswerCallTitle": "Answer Call",
    "AnswerCallTooltip": "Answer the currently alerting call.",
    "ClearCallTitle": "Clear Call",
    "ClearCallTooltip": "End the corresponding call.",
    "AdminOnlyTitle": "Admin Only",
    "AdminOnlyTooltip": "Administrator only actions.",
    "DeletePhantomTitle": "Delete Phantom Call",
    "DeletePhantomTooltip": "Force the application to stop modelling the corresponding call as active, which may adversely affect call statistics.",
    "NAME": "RowOptions",
    "RowOptions_AdvancedTitle": "Advanced"
}
